<template>
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="304.000000pt" height="90.000000pt" viewBox="0 0 304.000000 90.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,90.000000) scale(0.100000,-0.100000)"
fill="#fff" stroke="none">
<path d="M73 852 c-38 -36 -60 -77 -69 -130 -14 -89 73 -190 261 -302 113 -68
212 -155 236 -208 13 -30 14 -30 32 -14 50 45 61 125 27 192 -30 60 -110 133
-238 219 -122 82 -219 170 -228 208 -3 11 -1 31 6 42 14 28 11 27 -27 -7z"/>
<path d="M733 868 l-53 -10 0 -344 0 -344 65 0 65 0 0 184 c0 158 2 185 16
190 30 12 72 6 95 -13 23 -19 24 -24 27 -190 l3 -171 65 0 64 0 0 158 c-1 211
-12 253 -84 306 -22 17 -42 21 -107 21 l-79 0 0 113 c0 83 -3 112 -12 111 -7
-1 -37 -6 -65 -11z"/>
<path d="M402 854 c-16 -11 -22 -25 -22 -53 0 -46 24 -71 68 -71 33 0 72 38
72 70 0 10 -9 29 -21 44 -24 30 -63 34 -97 10z"/>
<path d="M1202 649 c-28 -8 -32 -13 -26 -37 3 -15 7 -36 9 -48 4 -19 10 -20
87 -16 92 5 124 -9 130 -57 3 -24 1 -24 -77 -26 -135 -2 -195 -49 -195 -152 0
-61 29 -109 77 -129 52 -22 157 -27 243 -12 l75 13 0 180 c0 162 -2 183 -20
214 -37 63 -65 76 -173 78 -53 1 -112 -2 -130 -8z m206 -326 c3 -49 1 -53 -23
-59 -32 -8 -92 1 -111 17 -8 6 -14 24 -14 40 0 40 33 60 95 57 l50 -3 3 -52z"/>
<path d="M1675 645 c-27 -8 -53 -14 -57 -15 -5 0 -8 -103 -8 -230 l0 -230 65
0 65 0 0 184 c0 212 -4 204 95 191 l53 -6 10 48 c7 29 7 52 2 57 -16 16 -171
17 -225 1z"/>
<path d="M1993 648 l-53 -10 0 -319 0 -319 65 0 65 0 0 91 0 91 33 -9 c97 -25
185 6 231 81 25 40 30 60 34 130 7 134 -29 209 -122 252 -56 26 -151 31 -253
12z m195 -114 c34 -24 52 -68 52 -129 0 -101 -48 -147 -131 -125 l-39 11 0
123 c0 67 3 126 7 129 12 13 89 7 111 -9z"/>
<path d="M50 300 c-24 -24 -26 -67 -4 -98 20 -28 83 -31 107 -4 40 45 6 122
-53 122 -17 0 -39 -9 -50 -20z"/>
</g>
</svg>


</template>

<script>
export default {
    name: 'LogoSharp',
}
</script>

<style lang="scss" scoped>
</style>